import { copyToClipboard } from "helpers/utils"
import React, { useState } from "react"
import toast from "react-hot-toast"

import { Form, FormGroup, Input, Label, Row, Col } from "reactstrap"

const RefferalInfo = ({ userDetails }) => {
  const url = `${process.env.REACT_APP_PUBLIC_URL}/register?referralcode=${userDetails?.unique_code}`
  return (
    <>
      <Row className="">
        <Col xl={12}>
          <div className="platform-heading-section mb-4">
            <h4>Referral Link</h4>
            <p>Share with investors to register with your referral code.</p>
          </div>
        </Col>
        <FormGroup row className="mb-4">
          <Label className="form-label" md={3}>
            Referral Link
          </Label>
          <Col md={4}>
            <Input
              id=""
              value={url}
              disabled
              name="text"
              placeholder="Referral Link"
              type="text"
              className="form-control"
            />
          </Col>

          <Col md={5}>
            <button
              type="button"
              onClick={() =>
                copyToClipboard(url).then(() => toast.success("Link Copied"))
              }
              className="btn btn-cancel w-md"
            >
              Copy Referral Link
            </button>
          </Col>
        </FormGroup>
        <FormGroup row className="mb-4">
          <Label className="form-label" md={3}>
            Referral Code
          </Label>
          <Col md={4}>
            <Input
              id=""
              value={userDetails?.unique_code}
              disabled
              name="text"
              placeholder="Referral Code"
              type="text"
              className="form-control"
            />
          </Col>

          <Col md={5}>
            <button
              type="button"
              onClick={() =>
                copyToClipboard(userDetails?.unique_code).then(() =>
                  toast.success("Link Copied")
                )
              }
              className="btn btn-cancel w-md"
            >
              Copy Referral Code
            </button>
          </Col>
        </FormGroup>
      </Row>
    </>
  )
}

export default RefferalInfo
